module.exports = __webpack_public_path__ + "static/media/20170122_184805.74233596.jpg";